import React from 'react';

export default function WelcomePopup({ onClose }) {
  return (
    <div className="welcome-overlay">
      <div className="welcome-modal">
        <button className="welcome-close" onClick={onClose} aria-label="Close">
          ✕
        </button>
        
        <h1 className="welcome-title">Welcome to Pin The Bay!</h1>
        
        <div className="welcome-content">
          <div className="welcome-section">
            <h2>How to Play</h2>
            <ol className="welcome-list">
              <li>Look at the photo of a Tampa Bay location</li>
              <li>Click "Reveal Map" to see the map</li>
              <li>Drag the pin to where you think the photo was taken</li>
              <li>Submit your guess and see how close you were!</li>
            </ol>
          </div>
          
          <div className="welcome-section">
            <h2>Scoring</h2>
            <p>Your score is based on:</p>
            <ul className="welcome-list">
              <li><strong>Distance</strong> - How close your guess was (in miles)</li>
              <li><strong>Time</strong> - How fast you made your guess</li>
            </ul>
            <p className="welcome-note">Lower distance and faster time = better rank!</p>
          </div>
          
          <div className="welcome-section">
            <h2>Daily Challenge</h2>
            <p>A new location is featured every day. Come back tomorrow for a new challenge!</p>
          </div>
        </div>
        
        <button className="welcome-start-btn" onClick={onClose}>
          Let's Play!
        </button>
      </div>
    </div>
  );
}